import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=6c1a52c5&scoped=true&lang=pug"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a52c5",
  null
  
)

export default component.exports